import { useState } from 'react';
import './menu.scss';

const Menu = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <nav className="header__menu">
      <ul>
        <li>
          <a className="link-theme" href="/#a-propos">
            À PROPOS
          </a>
        </li>
        <li>
          <a className="link-theme" href="/#skills">
            COMPÉTENCES
          </a>
        </li>
        <li>
          <a className="link-theme" href="/#projets">
            PROJETS
          </a>
        </li>
        <li
          className="dropdown-container"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <span className="link-theme dropdown-trigger" onClick={toggleDropdown}>
            WEBSITE <i className={`fas fa-chevron-down ${dropdownOpen ? 'open' : ''}`}></i>
          </span>
          {dropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <a href="https://site-plombier-two.vercel.app/" target="_blank" rel="noopener noreferrer">
                  Plombier
                </a>
              </li>
              <li>
                <a href="https://coach-elite-iota.vercel.app/" target="_blank" rel="noopener noreferrer">
                  Coach privé
                </a>
              </li>
            </ul>
          )}
        </li>
        <li>
          <a className="link-theme" href="/#contact">
            CONTACT
          </a>
        </li>
        <li>
          <label htmlFor="theme-switch" className="link-theme" style={{ cursor: 'pointer' }}>
            MODE
          </label>
        </li>
      </ul>
    </nav>
  );
};

export default Menu;
